import Vue from 'vue';

import VueI18n from 'vue-i18n';
import enUs from '../locale/en-US.json';

Vue.use(VueI18n);

export default new VueI18n({
	locale: 'en',
	silentTranslationWarn: true,
	fallbackLocale: 'en',
	messages: {
		en: enUs,
	},
});



// WEBPACK FOOTER //
// ./src/plugins/i18n.js